export default __webpack_public_path__ + "static/media/content-5-transparent.3a99c4a7.png";